<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="flex-wrap">
            <span class="text-subtitle-1 font-weight-bold mr-4 mb-2">
              <v-icon left color="primary">mdi-video-outline</v-icon>
              Clases pre grabadas
            </span>
            <v-spacer></v-spacer>
            <div class="d-flex flex-wrap align-center">
              <v-btn
                color="primary"
                outlined
                class="text-capitalize mr-2 mb-2"
                :to="{ name: 'RecursoCursoPregrabado' }"
                small
                tile
              >
                <v-icon left small>mdi-book-education</v-icon>
                Catálogo del curso
              </v-btn>
              <v-btn
                color="primary"
                dark
                class="text-capitalize mr-2 mb-2"
                @click="abrirDialogVideo"
                small
                tile
              >
                <v-icon left small>mdi-plus</v-icon>
                Subir video
              </v-btn>
              <v-btn
                color="primary"
                class="text-capitalize mb-2"
                @click="initialize"
                small
                tile
                outlined
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar
              </v-btn>
            </div>
          </v-card-title>

          <!-- Filtros por INBI, FAST, Nivel, Curso -->
          <v-card-text>
            <v-row class="mb-3">
              <v-col cols="12" md="3" class="pb-0">
                <v-radio-group v-model="escuela" row dense hide-details class="mt-0 pt-0">
                  <v-radio label="INBI" :value="1" color="colorinbi"></v-radio>
                  <v-radio label="FAST" :value="2" color="colorfast"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="3" lg="2" class="pb-0">
                <v-select
                  :items="niveles"
                  v-model="filtroNivel"
                  label="Nivel"
                  filled
                  dense
                  clearable
                  item-text="nivel"
                  item-value="id_nivel"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" lg="2" class="pb-0">
                <v-select
                  :items="cursos"
                  v-model="filtroCurso"
                  label="Curso"
                  filled
                  dense
                  clearable
                  item-text="curso"
                  item-value="id_curso"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" lg="3" class="pb-0">
                <v-text-field
                  v-model="search"
                  label="Buscar por nombre"
                  filled
                  append-icon="mdi-magnify"
                  dense
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filterVideos"
              class="elevation-0"
              :search="search"
              :mobile-breakpoint="100"
              dense
              loading-text="Cargando..."
              no-data-text="No hay videos. Sube uno para comenzar."
            >
              <template v-slot:item.acciones="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      @click="editarVideo(item)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                      @click="activarAGrupo(item)"
                    >
                      <v-icon small>mdi-account-group</v-icon>
                    </v-btn>
                  </template>
                  <span>Activar a grupo</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      color="info"
                      v-bind="attrs"
                      v-on="on"
                      @click="verPreguntas(item)"
                    >
                      <v-icon small>mdi-help-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver preguntas</span>
                </v-tooltip>
              </template>

              <template v-slot:item.preguntas_count="{ item }">
                <v-chip x-small :color="item.preguntas_count > 0 ? 'success' : 'grey'">
                  {{ item.preguntas_count || 0 }} preguntas
                </v-chip>
              </template>

              <template v-slot:item.grupos_activos="{ item }">
                <v-chip x-small color="primary" v-if="(item.grupos_activos || []).length">
                  {{ (item.grupos_activos || []).length }} grupos
                </v-chip>
                <span v-else class="grey--text caption">Sin asignar</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog: Subir/Editar video -->
    <v-dialog v-model="dialogVideo" max-width="700" persistent>
      <v-card>
        <v-card-title>{{ videoEditando ? 'Editar video' : 'Subir video' }}</v-card-title>
        <v-card-text>
          <v-form ref="formVideo">
            <v-text-field
              v-model="formVideo.titulo"
              label="Título del video *"
              filled
              dense
              :rules="[v => !!v || 'Requerido']"
            ></v-text-field>
            <v-textarea
              v-model="formVideo.descripcion"
              label="Descripción"
              filled
              dense
              rows="2"
            ></v-textarea>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="formVideo.id_nivel"
                  :items="niveles"
                  label="Nivel *"
                  filled
                  dense
                  item-text="nivel"
                  item-value="id_nivel"
                  :rules="[v => !!v || 'Requerido']"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="formVideo.id_curso"
                  :items="cursos"
                  label="Curso *"
                  filled
                  dense
                  item-text="curso"
                  item-value="id_curso"
                  :rules="[v => !!v || 'Requerido']"
                ></v-select>
              </v-col>
            </v-row>
            <v-file-input
              v-if="!videoEditando"
              v-model="formVideo.archivo"
              label="Archivo de video (mp4, webm, max. 200 MB) *"
              accept="video/mp4,video/webm,.mp4,.webm"
              show-size
              filled
              dense
              :rules="videoEditando ? [] : [v => !!v || 'Requerido', v => !v || (v.size && v.size <= 209715200) || 'Máx. 200 MB']"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogVideo">Cancelar</v-btn>
          <v-btn color="primary" :loading="cargar" @click="guardarVideo">
            {{ videoEditando ? 'Guardar' : 'Subir' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Preguntas de opción múltiple -->
    <v-dialog v-model="dialogPreguntas" max-width="800" persistent>
      <v-card>
        <v-card-title>
          Preguntas del video: {{ videoSeleccionado ? videoSeleccionado.titulo : '' }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="cerrarDialogPreguntas">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn color="primary" small class="mb-3" @click="agregarPregunta">
            <v-icon left small>mdi-plus</v-icon>
            Agregar pregunta
          </v-btn>
          <v-list v-if="preguntas.length" dense>
            <v-list-item v-for="(p, i) in preguntas" :key="i" class="mb-2">
              <v-list-item-content>
                <v-list-item-title class="body-2">
                  {{ i + 1 }}. {{ p.pregunta }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  <v-chip v-for="(op, j) in (p.opciones || [])" :key="j" x-small class="mr-1"
                    :color="j === p.respuesta_correcta ? 'success' : 'grey lighten-2'">
                    {{ String.fromCharCode(65 + j) }}) {{ op }}
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon x-small @click="editarPregunta(i)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon x-small color="error" @click="eliminarPregunta(i)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <p v-else class="grey--text caption">No hay preguntas. Agrega al menos una.</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog: Agregar/Editar pregunta -->
    <v-dialog v-model="dialogPreguntaForm" max-width="550" persistent>
      <v-card>
        <v-card-title>{{ editandoPreguntaIndex >= 0 ? 'Editar pregunta' : 'Nueva pregunta' }}</v-card-title>
        <v-card-text>
          <v-form ref="formPregunta">
            <v-text-field
              v-model="formPregunta.pregunta"
              label="Pregunta *"
              filled
              dense
              :rules="[v => !!v || 'Requerido']"
            ></v-text-field>
            <v-subheader>Opciones (marca la respuesta correcta)</v-subheader>
            <v-radio-group v-model="formPregunta.respuesta_correcta" mandatory>
              <v-text-field
                v-for="(_, i) in 4"
                :key="i"
                v-model="formPregunta.opciones[i]"
                :label="`Opción ${String.fromCharCode(65 + i)} *`"
                filled
                dense
                class="mb-1"
                :rules="[v => !!v || 'Requerido']"
              ></v-text-field>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogPreguntaForm">Cancelar</v-btn>
          <v-btn color="primary" :loading="cargar" @click="guardarPregunta">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Activar video a grupos -->
    <v-dialog v-model="dialogActivarGrupo" max-width="900" persistent>
      <v-card>
        <v-card-title>
          Activar video a grupos: {{ videoParaActivar ? videoParaActivar.titulo : '' }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="cerrarDialogActivarGrupo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-2">
            <v-col cols="12" md="4">
              <v-select
                :items="planteles"
                v-model="filtroPlantel"
                label="Plantel"
                filled
                dense
                clearable
                item-text="plantel"
                item-value="plantel"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                :items="niveles"
                v-model="filtroNivelGrupos"
                label="Nivel"
                filled
                dense
                clearable
                item-text="nivel"
                item-value="nivel"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                :items="ciclos"
                v-model="filtroCiclo"
                label="Ciclo"
                filled
                dense
                clearable
                item-text="ciclo"
                item-value="ciclo"
              ></v-select>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersGrupos"
            :items="filterGruposParaActivar"
            item-key="id_grupo"
            show-select
            v-model="gruposSeleccionados"
            dense
            hide-default-footer
            class="elevation-0"
          >
            <template v-slot:item.activo="{ item }">
              <v-chip x-small :color="item.video_activo ? 'success' : 'grey'">
                {{ item.video_activo ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogActivarGrupo">Cancelar</v-btn>
          <v-btn color="primary" :loading="cargar" :disabled="!gruposSeleccionados.length" @click="guardarActivacion">
            Activar a {{ gruposSeleccionados.length }} grupo(s)
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';

export default {
  components: { Alerta, carga },
  mixins: [validarErrores],

  data: () => ({
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    respuestaAlerta: false,
    cargar: false,

    escuela: 1,
    filtroNivel: null,
    filtroCurso: null,
    search: '',

    videos: [],
    headers: [
      { text: 'ID', value: 'id_clase_pregrabada', width: 80 },
      { text: 'Título', value: 'titulo' },
      { text: 'Nivel', value: 'nivel' },
      { text: 'Curso', value: 'curso' },
      { text: 'Preguntas', value: 'preguntas_count', sortable: false },
      { text: 'Grupos activos', value: 'grupos_activos', sortable: false },
      { text: 'Acciones', value: 'acciones', sortable: false, width: 140 }
    ],

    dialogVideo: false,
    videoEditando: null,
    formVideo: {
      titulo: '',
      descripcion: '',
      id_nivel: null,
      id_curso: null,
      archivo: null
    },

    dialogPreguntas: false,
    videoSeleccionado: null,
    preguntas: [],
    dialogPreguntaForm: false,
    editandoPreguntaIndex: -1,
    formPregunta: {
      pregunta: '',
      opciones: ['', '', '', ''],
      respuesta_correcta: 0
    },

    dialogActivarGrupo: false,
    videoParaActivar: null,
    grupos: [],
    gruposSeleccionados: [],
    filtroPlantel: null,
    filtroNivelGrupos: null,
    filtroCiclo: null,
    planteles: [],
    niveles: [],
    cursos: [],
    ciclos: [],
    headersGrupos: [
      { text: 'ID', value: 'id_grupo', width: 70 },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Nivel', value: 'nivel' },
      { text: 'Ciclo', value: 'ciclo' },
      { text: 'Estado', value: 'activo', sortable: false }
    ]
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP', 'getEscuela']),

    filterVideos() {
      let list = this.videos;
      if (this.filtroNivel) {
        list = list.filter(v => v.id_nivel === this.filtroNivel);
      }
      if (this.filtroCurso) {
        list = list.filter(v => v.id_curso === this.filtroCurso);
      }
      return list;
    },

    filterGruposParaActivar() {
      let list = this.grupos;
      if (this.filtroPlantel) {
        list = list.filter(g => g.plantel === this.filtroPlantel);
      }
      if (this.filtroNivelGrupos) {
        list = list.filter(g => g.nivel === this.filtroNivelGrupos);
      }
      if (this.filtroCiclo) {
        list = list.filter(g => g.ciclo === this.filtroCiclo);
      }
      return list;
    }
  },

  watch: {
    escuela() {
      this.initialize();
      this.getCursos();
    }
  },

  async created() {
    await this.getNiveles();
    await this.getCursos();
    await this.initialize();
  },

  methods: {
    async initialize() {
      this.cargar = true;
      this.videos = [];
      try {
        const res = await this.$http.get('clases.pregrabadas.list', {
          params: { escuela: this.escuela }
        });
        this.videos = res.data || [];
      } catch (e) {
        this.videos = [];
        if (e.response && e.response.status !== 404) {
          this.validarError((e.response && e.response.data && e.response.data.message) || 'Error al cargar');
        }
      } finally {
        this.cargar = false;
      }
    },

    async getNiveles() {
      try {
        const res = await this.$http.get('niveles.activos');
        this.niveles = res.data || [];
      } catch (e) {
        this.niveles = [];
      }
    },

    async getCursos() {
      try {
        const res = await this.$http.get('escuela.cursos.activos', {
          params: { escuela: this.escuela }
        });
        this.cursos = (res.data || []).filter(c => c.escuela == this.escuela);
        if (!this.cursos.length) {
          const r2 = await this.$http.get('cursos.activos');
          this.cursos = r2.data || [];
        }
      } catch (e) {
        try {
          const r2 = await this.$http.get('cursos.activos');
          this.cursos = r2.data || [];
        } catch (_) {
          this.cursos = [];
        }
      }
    },

    abrirDialogVideo() {
      this.videoEditando = null;
      this.formVideo = {
        titulo: '',
        descripcion: '',
        id_nivel: null,
        id_curso: null,
        archivo: null
      };
      this.dialogVideo = true;
      this.$nextTick(() => {
        if (this.$refs.formVideo) this.$refs.formVideo.resetValidation();
      });
    },

    cerrarDialogVideo() {
      this.dialogVideo = false;
      this.videoEditando = null;
    },

    editarVideo(item) {
      this.videoEditando = item;
      this.formVideo = {
        titulo: item.titulo,
        descripcion: item.descripcion || '',
        id_nivel: item.id_nivel,
        id_curso: item.id_curso,
        archivo: null
      };
      this.dialogVideo = true;
    },

    async guardarVideo() {
      if (!this.$refs.formVideo.validate()) return;
      this.cargar = true;
      try {
        if (this.videoEditando) {
          await this.$http.post('clases.pregrabadas.update/' + this.videoEditando.id_clase_pregrabada, {
            titulo: this.formVideo.titulo,
            descripcion: this.formVideo.descripcion,
            id_nivel: this.formVideo.id_nivel,
            id_curso: this.formVideo.id_curso,
            escuela: this.escuela
          });
          this.validarSuccess('Video actualizado');
        } else {
          const fd = new FormData();
          fd.append('titulo', this.formVideo.titulo);
          fd.append('descripcion', this.formVideo.descripcion || '');
          fd.append('id_nivel', this.formVideo.id_nivel);
          fd.append('id_curso', this.formVideo.id_curso);
          fd.append('escuela', this.escuela);
          fd.append('archivo', this.formVideo.archivo);
          await this.$http.post('clases.pregrabadas.add', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          this.validarSuccess('Video subido correctamente');
        }
        this.cerrarDialogVideo();
        await this.initialize();
      } catch (e) {
        this.validarError((e.response && e.response.data && e.response.data.message) || 'Error al guardar');
      } finally {
        this.cargar = false;
      }
    },

    verPreguntas(item) {
      this.videoSeleccionado = item;
      this.preguntas = [...(item.preguntas || [])];
      this.dialogPreguntas = true;
    },

    cerrarDialogPreguntas() {
      this.dialogPreguntas = false;
      this.videoSeleccionado = null;
      this.preguntas = [];
    },

    agregarPregunta() {
      this.editandoPreguntaIndex = -1;
      this.formPregunta = {
        pregunta: '',
        opciones: ['', '', '', ''],
        respuesta_correcta: 0
      };
      this.dialogPreguntaForm = true;
    },

    editarPregunta(index) {
      const p = this.preguntas[index];
      this.editandoPreguntaIndex = index;
      this.formPregunta = {
        pregunta: p.pregunta,
        opciones: [...(p.opciones || ['', '', '', ''])],
        respuesta_correcta: (p.respuesta_correcta != null) ? p.respuesta_correcta : 0
      };
      while (this.formPregunta.opciones.length < 4) this.formPregunta.opciones.push('');
      this.dialogPreguntaForm = true;
    },

    eliminarPregunta(index) {
      this.preguntas.splice(index, 1);
    },

    cerrarDialogPreguntaForm() {
      this.dialogPreguntaForm = false;
      this.editandoPreguntaIndex = -1;
    },

    async guardarPregunta() {
      if (!this.$refs.formPregunta.validate()) return;
      const p = {
        pregunta: this.formPregunta.pregunta,
        opciones: this.formPregunta.opciones.filter(o => o),
        respuesta_correcta: this.formPregunta.respuesta_correcta
      };
      if (this.editandoPreguntaIndex >= 0) {
        this.preguntas.splice(this.editandoPreguntaIndex, 1, p);
      } else {
        this.preguntas.push(p);
      }
      this.cargar = true;
      try {
        await this.$http.post('clases.pregrabadas.preguntas.save/' + this.videoSeleccionado.id_clase_pregrabada, {
          preguntas: this.preguntas
        });
        this.validarSuccess('Preguntas guardadas');
        this.cerrarDialogPreguntaForm();
        await this.initialize();
      } catch (e) {
        this.validarError((e.response && e.response.data && e.response.data.message) || 'Error al guardar');
      } finally {
        this.cargar = false;
      }
    },

    async activarAGrupo(item) {
      this.videoParaActivar = item;
      this.gruposSeleccionados = [];
      this.filtroPlantel = null;
      this.filtroNivelGrupos = null;
      this.filtroCiclo = null;
      this.cargar = true;
      try {
        const ruta = `grupos.habiles/${this.escuela}`;
        const res = await this.$http.get(ruta);
        const data = res.data;
        this.grupos = data.grupos || [];
        this.planteles = [...new Set((this.grupos || []).map(g => g.plantel).filter(Boolean))];
        this.ciclos = [...new Set((this.grupos || []).map(g => g.ciclo).filter(Boolean))];
        this.dialogActivarGrupo = true;
      } catch (e) {
        this.validarError((e.response && e.response.data && e.response.data.message) || 'Error al cargar grupos');
      } finally {
        this.cargar = false;
      }
    },

    cerrarDialogActivarGrupo() {
      this.dialogActivarGrupo = false;
      this.videoParaActivar = null;
      this.gruposSeleccionados = [];
    },

    async guardarActivacion() {
      if (!this.videoParaActivar || !this.gruposSeleccionados.length) return;
      this.cargar = true;
      try {
        await this.$http.post('clases.pregrabadas.activate.grupos', {
          id_clase_pregrabada: this.videoParaActivar.id_clase_pregrabada,
          id_grupos: this.gruposSeleccionados.map(g => g.id_grupo)
        });
        this.validarSuccess('Video activado para los grupos seleccionados');
        this.cerrarDialogActivarGrupo();
        await this.initialize();
      } catch (e) {
        this.validarError((e.response && e.response.data && e.response.data.message) || 'Error al activar');
      } finally {
        this.cargar = false;
      }
    }
  }
};
</script>
